import { ChevronDown } from "lucide-react";
import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MyContext } from "../hooks/MyContextProvider";

const Header = () => {
  const navigate = useNavigate();
  const { updateToken, updateUser, setOpen, open } = useContext(MyContext);

  return (
    <div class="page-header">
      <div class="header-wrapper row m-0">
        <div class="header-logo-wrapper col-auto p-0">
          <div
            class="toggle-sidebar"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setOpen(!open);
            }}
          >
            {" "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="balck"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              style={{ stroke: "black" }}
              class="feather feather-align-center status_toggle middle sidebar-toggle"
            >
              <line x1="18" y1="10" x2="6" y2="10"></line>
              <line x1="21" y1="6" x2="3" y2="6"></line>
              <line x1="21" y1="14" x2="3" y2="14"></line>
              <line x1="18" y1="18" x2="6" y2="18"></line>
            </svg>
          </div>
        </div>
        <div class="left-header col-xxl-5 col-xl-6 col-lg-5 col-md-4 col-sm-3 p-0">
          <div>
            <Link class="toggle-sidebar" to="/">
              <i class="iconly-Category icli"> </i>
            </Link>
            <div class="d-flex align-items-center gap-2">
              <h4 class="f-w-600">Welcome vantage Pinnacle</h4>
              <img
                class="mt-0"
                src="https://admin.pixelstrap.net/riho/assets/images/hand.gif"
                alt="hand-gif"
              />
            </div>
          </div>
          <div class="welcome-content d-xl-block d-none">
            <span class="text-truncate col-12">
              Here’s what’s happening with your store today.
            </span>
          </div>
        </div>
        <div class="nav-right col-xxl-7 col-xl-6 col-md-7 col-8 pull-right right-header p-0 ms-auto">
          <ul class="nav-menus">
            <li class="profile-nav onhover-dropdown">
              <div class="media profile-media">
                <img
                  class="b-r-10"
                  src="https://admin.pixelstrap.net/riho/assets/images/dashboard/profile.png"
                  alt=""
                />
                <div class="media-body d-xxl-block d-none box-col-none">
                  <div class="d-flex align-items-center gap-2">
                    <span>Vinatage Pinnacle </span>
                    <ChevronDown />
                  </div>
                  <p class="mb-0 font-roboto">Admin</p>
                </div>
              </div>
              <ul
                style={{ left: 53 }}
                class="profile-dropdown onhover-show-div"
              >
                <li>
                  <Link to="/profile">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-user"
                    >
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                    <span>My Profile</span>
                  </Link>
                </li>

                <li>
                  <Link
                    class="btn btn-pill btn-outline-primary btn-sm"
                    onClick={() => {
                      localStorage.clear();
                      updateToken("");
                      updateUser({});
                      navigate("/login");
                    }}
                  >
                    Log Out
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Header;
